import axios from 'axios';
import {useState, useEffect, FC} from 'react';

import {text} from '../../text';
import {URLS} from '../../config';
import {hooks} from '../../hooks';
import {theme} from '../../constants';
import {components} from '../../components';
import {actions} from '../../store/actions';

export const WishlistEmpty: FC = () => {
  const dispatch = hooks.useAppDispatch();
  const navigate = hooks.useAppNavigate();

  const [loading, setLoading] = useState<boolean>(true);
  const [productsData, setProductsData] = useState<any>([]);

  const getData = async () => {
    setLoading(true);

    try {
      const products = await axios
        .get(URLS.GET_PRODUCTS)
        .then((res) => res.data.products);

      setProductsData(products);
    } catch (error) {
//      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, []);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title='Wishlist'
        burger={true}
        basket={true}
        line={true}
      />
    );
  };

  const renderContent = (): JSX.Element => {
    if (loading) return <components.Loader />;

    return (
      <main
        style={{
          padding: '0px 20px 94px 20px',
          marginTop: 52,
          paddingTop: '18vh',
        }}
      >
        <img
          src={require('../../assets/icons/28.png')}
          alt='order successful'
          style={{
            width: 123.39,
            marginBottom: 4,
          }}
        />
        <text.H2
          style={{
            marginBottom: 14,
            textTransform: 'capitalize',
            color: theme.colors.mainColor,
          }}
        >
          Your Wishlist is empty!
        </text.H2>
        <text.T16
          style={{
            whiteSpace: 'pre-line',
            color: theme.colors.textColor,
            marginBottom: 30,
          }}
        >
          Looks like you haven't chosen the{'\n'}items you like.
        </text.T16>
        <components.Button
          title='Browse products'
          style={{
            color: '#fff',
          }}
          colorScheme='light'
          onClick={() => {
            dispatch(actions.resetFilters());
            navigate('/Shop', {state: {products: productsData}});
          }}
          containerStyle={{marginBottom: 10}}
        />
      </main>
    );
  };

  // const renderBottomTabBar = () => {
  //   return <components.BottomTabBar />;
  // };

  return (
    <>
      {renderHeader()}
      {renderContent()}
      {/* {renderBottomTabBar()} */}
    </>
  );
};
